// tslint:disable: variable-name
export default class LeaseLessor { 
    ls_no: number;
    name1?: string;
    name2?: string;
    name3?: string;
    addr1?: string;
    addr2?: string;
    cstz?: string;
    ssn?: string;
    hphone?: string;
    wphone?: string;
    mineral_ow_id?: number;
    sal?: string;

    static forTest = (leaseNumber: number): LeaseLessor => {
        let test: LeaseLessor = {
            ls_no: leaseNumber,
            name1: 'Jamie Jo Daniel and Chad Daniel, wife and husband',
            addr1: '2758 N. Dudney Road',
            cstz: 'MAGNOLIA, Arkansas, 71753',
            ssn: '111-11-1111 222-22-2222'
        };

        return test;
    };
}


// WEBPACK FOOTER //
// ./src/models/dlcLease/LeaseLessor.ts